import { render, staticRenderFns } from "./CorrectExerciseView.vue?vue&type=template&id=d25c6330&scoped=true&"
import script from "./CorrectExerciseView.vue?vue&type=script&lang=js&"
export * from "./CorrectExerciseView.vue?vue&type=script&lang=js&"
import style0 from "./CorrectExerciseView.vue?vue&type=style&index=0&lang=css&"
import style1 from "./CorrectExerciseView.vue?vue&type=style&index=1&id=d25c6330&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d25c6330",
  null
  
)

export default component.exports